import { render, staticRenderFns } from "./PortfolioStructureList.vue?vue&type=template&id=63b6c344&scoped=true&"
import script from "./PortfolioStructureList.vue?vue&type=script&lang=js&"
export * from "./PortfolioStructureList.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioStructureList.vue?vue&type=style&index=0&id=63b6c344&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b6c344",
  null
  
)

export default component.exports